// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ContactsPage = lazy(() => import('./pages/ContactsPage'));
const CompaniesPage = lazy(() => import('./pages/CompaniesPage'));
const RelationshipsPage = lazy(() => import('./pages/RelationshipsPage'));
const CustomFieldsPage = lazy(() => import('./pages/CustomFieldsPage'));
const CustomObjectsPage = lazy(() => import('./pages/CustomObjectsPage'));

export const BasicRoutes: RouteObject = {
  path: 'basic',
  element: <ModuleGuard moduleId="core.basic" />,
  children: [
    { path: 'contacts', element: <ContactsPage />, handle: { crumb: 'Contacts' } },
    { path: 'companies', element: <CompaniesPage />, handle: { crumb: 'Companies' } },
    { path: 'relationships', element: <RelationshipsPage />, handle: { crumb: 'Relationships' } },
    { path: 'roles', element: <Navigate to="/core/admin/roles" replace /> },
    { path: 'audit-log', element: <Navigate to="/core/admin/audit-log" replace /> },
    { path: 'custom-fields', element: <CustomFieldsPage />, handle: { crumb: 'Custom Fields' } },
    { path: 'custom-objects', element: <CustomObjectsPage />, handle: { crumb: 'Custom Objects' } },
    { path: 'views', element: <Navigate to="/core/basic/contacts" replace /> },
  ],
};
